export default "/images/coming-soon.svg?58c6b5609d4ed2664ac21ba33d2fe679";